module App.DispatchSummary {
	import ServiceAddress = App.Appointments.ServiceAddress;
	import ServiceRequestType = App.Appointments.ServiceRequestType;

	import ServiceNote = App.Appointments.ServiceNote;
	import Customer = App.Appointments.Customer;
	import DispatchCode = App.Appointments.DispatchCode;

	export type ServiceRequest = {
		id: number;
		service_address: ServiceAddress;
		service_request_type: ServiceRequestType;
		notes: ServiceNote[];
		promised_date: string;
		promised_time: string;
		service_request_status?: string;
		appointments: Appointment[];
		dispatch_code: DispatchCode;
		department: Department;
		customer: Customer;

		apptId?: number;
		apptTime?: string;
		apptStatus?: string;
		apptStatusIcon?: string;
		chipTech?: string;
		isChecked?: boolean;
		timeOrdering?: string;
		customerName?: string;
		chipTitle?: string;
		departmentColor?: string;
	}

	export interface Appointment {
		id: number;
		appointment_status: string;
		scheduled_date: string;
		scheduled_time: string;
		technician: { id: number, full_name: string };
	}

	export type Department = {
		id: number;
		name: string;
		abbreviation: string;
		color?: string;
	}

	export type Status = {
		id: number;
		name: number;
	}
}